import Vue from 'vue';
import * as releaseApi from '@/api/artist/releases.js';

const state = {
  // from query string in url (camelCase)
  query: {
  },
  filters: {
  },
  querys: {
    q: '',
    sort: '',
    page: 1,
    per_page: 10,
    type: '',
  },
  filtersList: [
    'type',
    'per_page',
  ],

  elements: [],

  pagination: {
    totalCount: 0,
    currentPage: 1,
    perPage: 10,
  },
};

const getters = {
  // querys: state => state.querys,
  keyword: state => _.get(state.query, 'q'),

  filtersList: state => state.filtersList,
  hasSelectedFilters: state => _.size(_.omitBy(state.filters, _.isNil)) > 0,

  perPage: state => state.pagination.perPage,
  currentPage: state => state.pagination.currentPage,
  totalCount: state => state.pagination.totalCount,
  // totalPageCount: state => Math.ceil(state.pagination.totalRows / state.pagination.perPage),
};

function updateStateElements(state, updatedElement) {
  if (!updatedElement.status) return;

  if (state.elements && state.elements.length) {
    const index = state.elements.findIndex(x => x.id === updatedElement.id);
    Vue.set(state.elements, index, { ...state.elements[index], ...updatedElement });
  }
}

const actions = {
  getReleaseFileInfo({ commit }, id) {
    return releaseApi.getReleaseFileInfo(id)
      .then((list) => {
        // console.log('listCollections', list);
        commit('setCollections', list);
        return list;
      });
  },
  setCurrentPage({ commit }, number) {
    commit('setCurrentPage', number);
  },

  listReleaseFiles({ commit }, params) {
    commit('setElements', []);

    return releaseApi.listReleaseFiles(params)
      .then((response) => {
        // commit results here
        commit('setElements', response.data.data);
        commit('setPagination', response.data);
      });
  },

  setSelectedElementIds({ commit }, ids) {
    commit('setSelectedElementIds', ids);
  },

  // eslint-disable-next-line
  deleteReleaseFile({ state }, id) {
    console.log('deleteReleaseFile action', id);
    if (!id) return;

    return releaseApi.deleteReleaseFile(id)
      .then((response) => {
        console.log('deleteReleaseFile deleted', response);

        const updateElement = response.data.data;
        if (_.size(updateElement)) {
          updateStateElements(state, updateElement);
        }

        return response;
      });
  },

  setQuery({ commit }, query) {
    const filters = {};

    if (query.type) {
      filters.type = query.type;
    }

    commit('setFilters', filters);
    commit('setQuery', query);
  },

  setFilters({ commit }, filters) {
    commit('setFilters', filters);
  },

  // setQuerys({ commit }, objects) {
  //   commit('setQuerys', objects);
  // },

  // resetQuerys({ commit }) {
  //   commit('resetQuerys');
  // },
};

const mutations = {
  setUploadFailList(state, list) {
    state.uploadFailList = list;
  },

  setMediatypeTabs(state, tabs) {
    state.mediatypeTabs = tabs;
  },

  setElementsCategories(state, list) {
    state.categories = list;
  },

  setCollections(state, list) {
    state.collections = list;
  },

  setSelectedElementIds(state, ids) {
    console.log('setSelectedElementIds', ids, ids.length);
    state.selectedElementIds = ids || [];
  },

  setQuery(state, query) {
    console.log('setQuery', query);
    state.query = query;

    // update hasSelectedFilters if have apply any filter on list
    // let status = false;
    // Object.keys(state.filtersList).map((key) => {
    //   console.log('setQuery', state.filtersList[key]);
    //   const filterName = state.filtersList[key];
    //   const filterValue = query[filterName];
    //   if (filterValue) {
    //     status = true;
    //     console.log('setQuery true', state.filtersList[key]);
    //   }
    // });
    // state.hasSelectedFilters = status;
  },

  // setQuerys(state, objects) {
  //   console.log('setQuerys', objects);
  //   state.querys = objects;

  //   // update hasSelectedFilters if have apply any filter on list
  //   let status = false;
  //   Object.keys(state.filtersList).map((key) => {
  //     console.log('setQuerys', state.filtersList[key]);
  //     const filterName = state.filtersList[key];
  //     const filterValue = objects[filterName];
  //     if (['default', ''].indexOf(filterValue) < 0) {
  //       status = true;
  //       console.log('setQuerys true', state.filtersList[key]);
  //     }
  //   });
  //   state.hasSelectedFilters = status;
  //   console.log('setQuerys', state.hasSelectedFilters);
  // },

  // resetQuerys(state) {
  //   state.querys = state.defaultQuerys;
  // },

  setFilters(state, filters) {
    state.filters = filters;
  },

  setElements(state, data) {
    state.elements = data;
  },

  setCurrentMediaType(state, mediaType) {
    state.currentMediaType = mediaType;
  },

  // pagination
  setCurrentPage(state, number) {
    state.pagination.currentPage = parseInt(number, 10);
  },

  setPerPage(state, number) {
    state.pagination.perPage = parseInt(number, 10);
  },

  setPagination(state, data) {
    state.pagination.currentPage = data.page;
    state.pagination.perPage = data.perPage;
    state.pagination.itemPerPage = data.perPage;
    state.pagination.totalCount = data.totalCount;
    // state.pagination.totalPage = Math.ceil(response.totalCount / response.perPage, 10);
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
